<template>
  <div v-if="authStore.user?.isGlobalAdmin && localitiesStore.localities.length > 0" class="ml-4">
    <select
      v-model="selectedLocalityId"
      class="block rounded-md border-gray-300 dark:border-gray-600 py-1.5 px-3 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm shadow-sm focus:border-blue-500 focus:ring-blue-500"
    >
      <option
        v-for="locality in localitiesStore.localities"
        :key="locality.id"
        :value="locality.id"
      >
        {{ locality.name }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useLocalitiesStore } from '@/stores/localities'
import { useRouter, useRoute } from 'vue-router'

const authStore = useAuthStore()
const localitiesStore = useLocalitiesStore()
const router = useRouter()
const route = useRoute()

// Computed getter reads from store; setter ONLY navigates.
// The router's beforeEach guard syncs the store from the route param,
// keeping the route as the single source of truth.
const selectedLocalityId = computed({
  get: () => localitiesStore.selectedLocalityId || null,
  set: (id: string | null) => {
    if (!id || id === localitiesStore.selectedLocalityId) return

    // Only navigate; router beforeEach will update the store
    if (route.params.localityId) {
      if (route.name) {
        router.push({
          name: route.name,
          params: { ...route.params, localityId: id },
          query: route.query,
        })
      } else {
        const newPath = route.path.replace(route.params.localityId as string, id)
        router.push(newPath)
      }
    }
  },
})
</script>
